(() => {
  const dialog = document.getElementById('bpp-support-panel');
  if (!dialog || !dialog.showModal || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const historyKey = 'bppSupportPanel';
  let frame = dialog.querySelector('iframe');
  let opener;
  let previousOverflow;
  let scrollPosition;
  let session;
  let historyStep = 0;
  let opened = false;
  let cleanupSession;
  let cleanupTimer;
  let pendingLink;
  let backdropPress = false;

  const addHistoryEntry = () => {
    historyStep += 1;
    history.pushState({ ...history.state, [historyKey]: { session, step: historyStep } }, '', location.href);
  };
  const watchFrame = () => {
    frame.addEventListener('load', () => {
      if (opened && !cleanupSession) addHistoryEntry();
    });
  };
  watchFrame();
  const outsidePanel = (event) => {
    const rect = dialog.getBoundingClientRect();
    return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
  };

  const restorePage = () => {
    opener?.focus({ preventScroll: true });
    if (scrollPosition) window.scrollTo({ left: scrollPosition.x, top: scrollPosition.y, behavior: 'instant' });
  };
  const openPanel = (link) => {
    if (opened) return;
    opener = link;
    scrollPosition = { x: window.scrollX, y: window.scrollY };
    previousOverflow = document.documentElement.style.overflow;
    session = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    historyStep = 0;
    addHistoryEntry();
    opened = true;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    frame.src = link.href;
  };
  const finishCleanup = () => {
    clearTimeout(cleanupTimer);
    cleanupSession = undefined;
    restorePage();
    if (pendingLink) {
      const link = pendingLink;
      pendingLink = undefined;
      openPanel(link);
    }
  };
  const cleanHistory = () => {
    clearTimeout(cleanupTimer);
    if (history.state?.[historyKey]?.session !== cleanupSession) {
      finishCleanup();
      return;
    }
    cleanupTimer = setTimeout(finishCleanup, 250);
    history.back();
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || dialog.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.protocol !== 'https:' || !['www.black-patch-performance.com', 'black-patch-performance.com'].includes(url.hostname)) return;
    event.preventDefault();
    if (cleanupSession || (opened && !dialog.open)) {
      pendingLink = link;
      return;
    }
    openPanel(link);
  });

  dialog.querySelector('[data-bpp-support-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('pointerdown', (event) => {
    backdropPress = event.target === dialog && outsidePanel(event);
  });
  dialog.addEventListener('pointerup', (event) => {
    if (backdropPress && event.target === dialog && outsidePanel(event)) dialog.close();
    backdropPress = false;
  });
  dialog.addEventListener('pointercancel', () => { backdropPress = false; });

  window.addEventListener('popstate', () => {
    if (cleanupSession) {
      cleanHistory();
      return;
    }
    if (dialog.open) dialog.close();
  });

  dialog.addEventListener('close', () => {
    if (!opened) return;
    opened = false;
    const entry = history.state?.[historyKey];
    backdropPress = false;
    const blankFrame = frame.cloneNode(false);
    blankFrame.removeAttribute('src');
    frame.replaceWith(blankFrame);
    frame = blankFrame;
    watchFrame();
    document.documentElement.style.overflow = previousOverflow || '';
    restorePage();
    if (entry?.session === session) {
      cleanupSession = session;
      cleanHistory();
    } else {
      finishCleanup();
    }
  });
})();
